<script setup lang="ts">
type TaskListData = App.StudentApp.Data.TaskListData;

import CardList from '@/components/studentParentApp/card/CardList.vue';
import CardListItem from '@/components/studentParentApp/card/CardListItem.vue';
import PageContainer from '@/components/studentParentApp/container/PageContainer.vue';
import PageSection from '@/components/studentParentApp/PageSection/PageSection.vue';
import StudentDashboard from '@/domains/student-app/components/tasks/StudentDashboard.vue';
import TaskItem from '@/domains/student-app/components/tasks/TaskItem.vue';
import EmptyState from '@/domains/student-app/components/tasks/EmptyState.vue';
import ArchiveBox from '@/images/archive-box.svg';
import Button from '@/components/button/Button.vue';
import AngleLeft from '@/icons/line/angle-left.svg';
import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';

defineProps<{
  todoTasksCount: number;
  completedTasksCount: number;
  taskLists: TaskListData[];
}>();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <StudentDashboard :todoTasksCount="todoTasksCount" :completedTasksCount="completedTasksCount">
    <!-- Empty state when no completed tasks -->
    <template v-if="taskLists.length === 0">
      <PageContainer class="mb-5">
        <CardList>
          <CardListItem>
            <EmptyState
              :icon="ArchiveBox"
              title="No completed tasks yet"
              description="Completed tasks will appear here"
              extraClasses="py-4"
            />
          </CardListItem>
        </CardList>
      </PageContainer>
    </template>

    <!-- Task Lists -->
    <template v-for="(taskList, index) in taskLists" :key="taskList.title">
      <component :is="index === 0 ? PageContainer : PageSection">
        <CardList :class="{ 'mb-5': index === 0 }">
          <template #header>
            <h2 class="text-xs font-bold uppercase leading-none text-slate-500">
              {{ taskList.title }}
            </h2>
          </template>
          <CardListItem
            v-for="task in taskList.tasks"
            :key="task.id"
            :value="task.title"
            :href="route('tasks.show', { task: task.id })"
          >
            <TaskItem :task="task" />
          </CardListItem>
        </CardList>
      </component>
    </template>
    <PageSection class="grow">
      <Button
        :iconLeft="AngleLeft"
        :size="ButtonSize.lg"
        :variant="ButtonVariant.outlined"
        :color="ButtonColor.primary"
        class="w-full"
        @click="router.get(route('student.dashboard.show'))"
      >
        To-do items
      </Button>
    </PageSection>
  </StudentDashboard>
</template>
